import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
  .wrapper-outer-div {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-right: 170px;
    #block1 {
      flex: 14%;
      span {
        display: flex !important;
        padding-left: 85px;
      }
    }
    #block2 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
    #block3 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
  }
`;
const SummarySubmissionHeaderSkeleton: React.FC = () => {
  return (
    <Wrapper className="skeleton-form-listing">
      <div className="wrapper-outer-div">
        <div id="block1">
          <span style={{ display: 'flex', flexDirection: 'column' }}>
            <Skeleton.Button style={{ width: '100px', height: '18px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block2">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block3">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block4">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
      </div>
    </Wrapper>
  );
};

export default SummarySubmissionHeaderSkeleton;
